import React, { useState, useRef, useEffect } from "react";
import "../styles/terminal.css";

export default function Terminal() {
  const [history, setHistory] = useState([]);
  const [input, setInput] = useState("");
  const [commandHistory, setCommandHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(null);
  const inputRef = useRef(null);

  const commands = {
    whoami: () =>
      "I'm Mert, a full-stack developer from Rotterdam, Netherlands.",
    help: () =>
      "Commands you can use: whoami, about, projects, contact, clear, ascii, joke, sudo, date, skills, github, alert, exit",
    about: () =>
      "I'm Mert Arinci, a passionate Full-Stack Developer based in Rotterdam, Netherlands. With expertise in both front-end and back-end technologies, I create robust, scalable, and user-friendly web applications since 2017.",
    projects: () => "You can check my projects from the _projects tab.",
    contact: () =>
      "E-mail: mert@arinci.nl & mertarinci96@gmail.com\nLinkedIn: linkedin.com/in/mert-arinci-7536ab26a/",
    clear: () => "__CLEAR__",
    ascii: () => `
    ┌─┐  
   ( •_•)  
   <)   )╯  Have a great day!  
    /   \\   
 `,
    joke: async () => await fetchJoke(),

    sudo: () => "Permission denied: you're not root.",
    date: () => {
      return new Date().toLocaleString("en-GB", {
        timeZone: "Europe/Amsterdam",
        hour12: false,
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
    exit: () => "There is no escape from the terminal!",
    skills: () =>
      `Skills:
    - JavaScript (React, Node.js, Next.js)
    - Python
    - Docker
    - SQL & NoSQL
    - REST APIs
    - Git & GitHub`,

    github: () => "https://github.com/mertarinci",
    alert: () => {
      alert("ALERT ALERT ALERT!");
      return "Alert triggered!";
    },
    bahadir: () => "Bahadiri cok seviyorum.",
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Joke fetch
  async function fetchJoke() {
    const res = await fetch(
      "https://official-joke-api.appspot.com/jokes/random"
    );
    const data = await res.json();
    return `${data.setup} — ${data.punchline}`;
  }

  const handleCommand = async () => {
    const command = input.trim();

    // önce komutu history'ye yaz
    setHistory((prev) => [...prev, `guest@Merts-Playground ~ # ${command}`]);

    if (!command) {
      setInput("");
      setHistoryIndex(null);
      return;
    }

    if (commands[command]) {
      let output;
      if (commands[command] instanceof Function) {
        // Eğer komut async ise await yap, değilse direkt çağır
        const result = commands[command]();
        output = result instanceof Promise ? await result : result;
      } else {
        output = commands[command];
      }

      if (output === "__CLEAR__") {
        setHistory([]);
      } else {
        setHistory((prev) => [...prev, output]);
      }
    } else {
      setHistory((prev) => [...prev, `Command not found: ${command}`]);
    }

    setCommandHistory((prev) => [...prev, command]);
    setInput("");
    setHistoryIndex(null);
  };

  const handleTerminalClick = () => {
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleCommand();
    } else if (e.key === "ArrowUp") {
      if (commandHistory.length === 0) return;
      const newIndex =
        historyIndex === null
          ? commandHistory.length - 1
          : Math.max(0, historyIndex - 1);
      setHistoryIndex(newIndex);
      setInput(commandHistory[newIndex]);
    } else if (e.key === "ArrowDown") {
      if (historyIndex === null) return;
      const newIndex = Math.min(commandHistory.length - 1, historyIndex + 1);
      setHistoryIndex(newIndex);
      setInput(commandHistory[newIndex] || "");
    } else if (e.key === "Tab") {
      e.preventDefault();
      const matches = Object.keys(commands).filter((cmd) =>
        cmd.startsWith(input)
      );
      if (matches.length === 1) {
        setInput(matches[0]);
      }
    }
  };

  return (
    <div className="terminal" onClick={handleTerminalClick}>
      <span className="hint-msg">
        Welcome to my terminal! Hint: You can start with "help"
      </span>
      {history.map((line, idx) => (
        <div key={idx}>
          {line.split("\n").map((l, i) => (
            <div key={i}>{l}</div>
          ))}
        </div>
      ))}
      <div className="input-line">
        <span>guest@Merts-Playground ~ # </span>
        <input
          ref={inputRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );
}
